export { default as GalleryCarousel } from "./GalleryCarousel";
